export default __webpack_public_path__ + "1624e9ac961b8135a202446e08d99831.png";